/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Tournament_Issue_TitleInputs */



/**
* | output |
* | --- |
* | "Issue Tournament Sanction" |
*
* @param {Sanction_Tournament_Issue_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_tournament_issue_title = /** @type {((inputs?: Sanction_Tournament_Issue_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Tournament_Issue_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Émettre une Sanction de Tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Emitir Sanción de Torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Emitir Sanção de Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Emetti Sanzione di Torneo")
	return /** @type {LocalizedString} */ ("Issue Tournament Sanction")
});